import EndPoint from 'Api/EndPoint';
import Client from 'Api/Client';

const endpoint = `${EndPoint.Host}/${EndPoint.Common}`;

export async function getTMapAddress(data) {
  return await Client.get(`${endpoint}/tMap/address`, data, true);
}

export async function getGoogleMapAutoComplete(data) {
  return await Client.get(`${endpoint}/googleMap/autoComplete`, data, true);
}

export async function getGoogleMapGeocode(data) {
  return await Client.get(`${endpoint}/googleMap/geocode`, data, true);
}
